export default {
  'areas.create.notification.success': 'Sucesso',
  'areas.create.notification.successDescription': 'Área cadastrada.',
  'areas.update.notification.success': 'Sucesso',
  'areas.update.notification.successDescription': 'Area atualizada.',
  'areas.remove.notification.success': 'Sucesso',
  'areas.remove.notification.successDescription': 'Area removida.',
  'areas.general.form.description': 'Descrição da Área',
  'areas.general.form.executionOrder': 'Orderm de Execução',
  'areas.general.form.button.remove': 'Remover',
  'areas.general.form.button.save': 'Salvar',
  'areas.modal.remove.title': 'Remover área',
  'areas.modal.remove.content': 'Deseja remover a área',
  'areas.modal.remove.button.ok': 'Remover',
  'areas.modal.remove.message.success': 'Área removido com sucesso!',
  'areas.modal.remove.message.error': 'Não foi possível remover a área!',
  'areas.page.button.newService': 'Nova Área',
  'areas.modal.create.title': 'Adicionar Área',
  'areas.modal.edit.title': 'Atualizar Área',
  'areas.modal.create.message.success': 'Área adicionada com sucesso!',
  'areas.modal.edit.message.success': 'Área atualizada com sucesso!',
  'areas.modal.message.error': 'Não foi possível executar a açao!',
  'areas.subareas': 'Sub-Áreas',
  'areas.subareas.create': 'Criar Nova Sub-Área',
  'areas.subareas.create.notification.success': 'Sucesso',
  'areas.subareas.create.notification.successDescription': 'Sub-Área criada.',
  'areas.subareas.update': 'Atualizar Sub-Área',
  'areas.subareas.update.notification.success': 'Sucesso',
  'areas.subareas.update.notification.successDescription':
    'Sub-Área atualizada.',
  'areas.subareas.description': 'Descrição da Sub-área',
  'areas.filter.company': 'Empresa',

  'areas.modal.report.title': 'Gerar Relatório',
  'areas.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'areas.modal.report.buttons.pdf': 'Gerar PDF',
  'areas.modal.report.buttons.rtf': 'Gerar RTF',
  'areas.modal.report.buttons.csv': 'Gerar CSV',
  'areas.modal.report.form.description': 'Descrição',
  'areas.notification.generate.report.title': 'Relatório gerado com sucesso',
  'areas.notification.generate.report.description':
    'Relatório de Áreas Gerado com Sucesso!',

  'areas.error.alreadyExists': 'Já existe essa área cadastrada!',
  'areas.error.remove.bonds':
    'Não foi possível concluir a ação devido a violação nos vínculos desse registro!',

  'areas.status.message.success': 'Status da area alterado com sucesso!',
};
